import { ARBITRATOR_ROLE_TYPES } from '../config/constants';

export function isSuperAdminArbitrator(auth = {}) {
  if (!auth || !auth.loggedIn) return false;
  if (auth.role_type === ARBITRATOR_ROLE_TYPES.SUPER_ADMIN) return true;
  return !auth.group_id;
}

export function getAssignedChapterId(auth = {}) {
  if (isSuperAdminArbitrator(auth) || !auth.group_id) return null;
  return String(auth.group_id);
}

export function memberBelongsToChapter(member, groupId) {
  if (!groupId) return true;
  const groupIds = member.group_ids || (member.groups || []).map((g) => g.id);
  return groupIds.some((id) => String(id) === String(groupId));
}

export function filterMembersByChapter(members, groupId) {
  if (!groupId) return members;
  return members.filter((member) => memberBelongsToChapter(member, groupId));
}

export function itemBelongsToChapter(item, groupId) {
  if (!groupId) return true;
  if (item.group_id && String(item.group_id) === String(groupId)) return true;
  const groupIds = item.group_ids
    || (item.groups || []).map((g) => g.id)
    || (item.group_name ? [] : []);
  if (groupIds.length > 0) {
    return groupIds.some((id) => String(id) === String(groupId));
  }
  if (item.group_name) {
    return true;
  }
  return false;
}

export function filterByAssignedChapter(items, auth = {}) {
  const groupId = getAssignedChapterId(auth);
  if (!groupId) return items;
  return items.filter((item) => itemBelongsToChapter(item, groupId));
}

export function filterGroupsForAuth(groups, auth = {}) {
  const groupId = getAssignedChapterId(auth);
  if (!groupId) return groups;
  return groups.filter((group) => String(group.id) === groupId);
}

export function hasPrivilege(auth, privilege) {
  if (isSuperAdminArbitrator(auth)) return true;
  const privileges = auth.privileges || [];
  return privileges.includes(privilege);
}
